import { TemplateType } from '@/constants/templateTypes';

/**
 * 根据输入字数预估执行时间（单位：秒）
 * @param wordCount 输入字数
 * @returns 预估执行时间（秒）
 */
export function estimateExecutionTime(wordCount: number): number {
  if (wordCount < 0) {
    throw new Error("字数不能为负数");
  }
  if (wordCount <= 20000) {
    return Math.round(20 + (wordCount / 20000) * 60);
  } else if (wordCount <= 30000) {
    // 20000 ~ 30000 字: 1 ~ 3 分钟 => 60 ~ 180 秒
    return Math.round(60 + ((wordCount - 20000) / 10000) * 120);
  } else if (wordCount <= 50000) {
    // 30000 ~ 50000 字: 3 ~ 5 分钟 => 180 ~ 300 秒
    return Math.round(180 + ((wordCount - 30000) / 20000) * 120);
  } else  {
    // 50000 ~ 80000 字: 5 ~ 8 分钟 => 300 ~ 480 秒
    return Math.round(300 + ((wordCount - 50000) / 30000) * 180);
  } 
}

/**
 * 根据模板类型和输入字数预估执行时间（单位：秒）
 * @param wordCount 输入字数
 * @param templateType 模板类型
 * @returns 预估执行时间（秒）
 */
export function estimateExecutionTimeByTemplate(wordCount: number, templateType: string): number {
  if (wordCount < 0) {
    throw new Error("字数不能为负数");
  }

  switch (templateType) {
    case TemplateType.DEEP:
      // 深度纪要时间估算
      if (wordCount <= 10000) {
        return 120; // 2分钟
      } else if (wordCount <= 20000) {
        return 180; // 3分钟
      } else if (wordCount <= 30000) {
        return 300; // 5分钟
      } else if (wordCount <= 50000) {
        return 420; // 7分钟
      } else {
        return 540; // 9分钟
      }

    case TemplateType.DIALOGUE:
    case TemplateType.KEY_POINTS:
      // 对话纪要、要点概述时间估算
      if (wordCount <= 40000) {
        return 60; // 1分钟
      } else {
        return 120; // 2分钟
      }

    case TemplateType.TASK_ASSIGNMENT:
      // 行动计划时间估算
      if (wordCount <= 10000) {
        return 60; // 1分钟
      } else if (wordCount <= 20000) {
        return 120; // 2分钟
      } else if (wordCount <= 30000) {
        return 180; // 3分钟
      } else if (wordCount <= 50000) {
        return 300; // 5分钟
      } else {
        return 420; // 7分钟
      }

    default:
      // 默认使用原有的时间估算逻辑
      return estimateExecutionTime(wordCount);
  }
}